import React from 'react'
import styled from '@emotion/styled'
import { array, bool, func, oneOfType, string } from 'prop-types'

// Import Components
import { Chevron } from '../svgs/Chevron'
import { useTheme } from 'emotion-theming'

// Styled Components via Emotion
const CategoryContainer = styled.div`
	display: block;
	padding: 10px 0;

	${({ theme }) => theme.MQ.M} {
		padding: 0;
	}

	@media (min-width: 1200px) and (max-width: 1300px) {
		margin: 0 auto;
	}

	${({ theme }) => theme.MQ.XL} {
		margin-left: auto;
		right: 0;
	}
`

const CategoryButton = styled.button`
	background: none;
	border: none;
	color: ${({ theme }) => theme.colors.white};
	cursor: pointer;
	display: inline-block;
	font-size: 20px;
	font-weight: 500;
	/** Next rule is needed for old stack */
	line-height: 30px;
	margin: 0;
	padding: 0;
	outline: none;
	text-align: left;

	${({ theme }) => theme.MQ.S} {
		font-size: 22px;
	}

	${({ theme }) => theme.MQ.M} {
		color: ${({ theme }) => theme.colors.primary};
		cursor: default;
	}
`

const Arrow = styled.span`
	display: inline-block;
	height: 7.6px;
	padding-left: 10px;
	width: 15px;

	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`

const DesktopOnly = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		display: block;
	}
`

const CategoryLinkGroup = styled.div`
	display: flex;
	flex-direction: column;
	line-height: 40px;
	padding: 10px 10px;

	a {
		color: #fff;
	}

	&:hover {
		color: #fff;
	}

	${({ theme }) => theme.MQ.M} {
		line-height: 40px;
		padding: 5px 0;

		a {
			color: ${({ theme }) => theme.colors.darkGrey};
		}
		& a:hover {
			color: ${({ theme }) => theme.colors.tertiary};
		}
	}
`

const MobileOnly = styled.div`
	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`

LinkGroup.propTypes = {
	activeCategory: oneOfType([bool, string]),
	categoryId: string.isRequired,
	categoryText: string.isRequired,
	handleCategoryClick: func.isRequired,
	links: array.isRequired,
}

/**
 * This is the LinkGroup component
 * On Desktop: it is laid out
 * On Mobile: all links are in their respective drawers
 */
export function LinkGroup(props) {
	const { activeCategory, categoryId, categoryText, handleCategoryClick, links } = props
	const {
		footer: { chevronColor },
	} = useTheme()
	return (
		<CategoryContainer>
			<CategoryButton onClick={() => handleCategoryClick(categoryId)}>
				{categoryText}
				<Arrow categoryId={categoryId} activeCategory={activeCategory}>
					<Chevron color={chevronColor} rotationDeg={activeCategory !== categoryId ? 180 : 0} />
				</Arrow>
			</CategoryButton>
			<DesktopOnly>
				<CategoryLinkGroup>{links}</CategoryLinkGroup>
			</DesktopOnly>
			<MobileOnly>{activeCategory === categoryId && <CategoryLinkGroup>{links}</CategoryLinkGroup>}</MobileOnly>
		</CategoryContainer>
	)
}
